<template>
    <div
      :class="['custom-button',sizeClass,isTransform?'custom-button-hover':'']"
      @click="$emit('click')"
    >
      <slot></slot>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CustomButton',
    props: {
      size: {
        type: String,
        default: 'default' // 默认大小 auto、small、default、large
      },
      isTransform:{
        type: Boolean,
        default: true //是否有悬浮过渡动画
      }
    },
    computed: {
      sizeClass() {
        return 'custom-button--' + this.size;
      }
    }
  }
  </script>
  
  <style scoped>
  .custom-button {
    font-size: 16px;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background: url('@/assets/img/btnbg1.png') no-repeat;
    background-size: contain;
    transition: transform .3s;
    color: #fff;

    background-size: 90%;
  }

  .custom-button-hover:hover {
    transform: translateX(10px);
  }
  
  .custom-button--auto {
    width:100%;
    height:100%;
  }


  .custom-button--small {
    width: 106px;
    height: 25px;
  }

  .custom-button--default {
    width: 190px;
    height: 41.04px;
  }

  .custom-button--large {
    width: 318px;
    height: 68.4px;
  }
  
  </style>
  